<template>
  <div :id="this.$route.name">
    <card id="ModulsTable">
      <template v-slot:header>
        <h4 class="d-inline">مشخصات ماژول سخت افزاری</h4>
        <hr />
      </template>
      <template v-slot:btnCustome>
        <a v-if="$IsAccess('AddModules')" class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="AddRow()" title="ردیف جدید">
          <h4>
            <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
          </h4>
        </a>
      </template>
      <template v-slot:content>
        <BnpGrid v-if="$store.state.renderComponent" :action="true" :propsRows="ModulesRows" :propsColumn="ColumnRiz" :hasRowNum="true">
          <template slot="action-slot" slot-scope="props">
            <button class="btn btn-lg text-secondary hover-warning" @click="copyCode(props.props)" title="کپی کد قفل"><i class="fad fa-lock"></i></button>
            <a v-if="$IsAccess('EditModules')" href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)" title=" ویرایش ">
              <h6><span class="fas fa-marker text-secondary hover-warning"></span></h6>
            </a>
            <button v-if="$IsAccess('AddModules')" class="btn btn-lg text-info" @click="copyRow(props.props)" title="کپی ردیف"><i class="fad fa-copy"></i></button>
          </template>
        </BnpGrid>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  components: { Card, BnpGrid },
  data() {
    return {
      ModulesRows: [],
      ColumnRiz: [],
      DataAxios_GetdatRiz: {
        ArryfildValue: {},
      },
    }
  },
  beforeMount() {
    var DataAxoisColumnRiz = {
      ArryfildValue: {
        SoftwareId: 2,
        UserId: 1,
        FormName: 'frmModules',
        ShowView: 0,
      },
      Method: 'post',
      Action: 'ReadGridColumns',
    }
    this.$GetColumns(DataAxoisColumnRiz, true)
      .then((data) => {
        this.ColumnRiz = data
      })
      .finally(() => {
        this.$store.state.renderComponent = false
        this.$nextTick(() => {
          this.$store.state.renderComponent = true
        })
      })
  },
  mounted() {
    this.DataAxios_GetdatRiz.Action = 'Modules/Index'
    this.DataAxios_GetdatRiz.ArryfildValue.tblCustomerId = this.CustomerId
    this.DataAxios_GetdatRiz.Method = 'Post'
    ;(this.DataAxios_GetdatRiz.Token = this.$session.get('Token')),
      this.$PostData(this.DataAxios_GetdatRiz)
        .then((data) => {
          this.ModulesRows = data
        })
        .finally(() => {
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
          })
        })
  },
  props: ['CustomerId', 'CustCode','CustomerName'],
  methods: {
    copyRow(row) {
      row.CustomerId = this.CustomerId
      row.CustCode = this.CustCode
      // console.log(row);
      this.$router.push({ name: 'DetailModules', params: { Status: 'Add', DataRow: row } })
    },
    OnEditNew(data) {
      data.CustomerId = this.CustomerId
      data.CustCode = this.CustCode
      this.$router.push({ name: 'DetailModules', params: { Status: 'Edit', DataRow: data } })
    },
    copyCode(row) {
      var Sample = {
        Sal: row.Sal.trim().replace( / +/g, ''),
        TblComboIdGrp7: row.TblComboIdGrp7 == 1219 ? 1 : row.TblComboIdGrp7 == 1176 ? 'Cash' : row.TblComboIdGrp7 == 1666 ? 'Off' : 'NF',
        LockCode: row.CustomerCode,
        Variz: row.Variz == true ? 2 : 1,
        Ghore: row.Ghore == true ? 2 : 1,
        PanelSMS: row.PanelSms == true ? 2 : 1,
        MandeNet: row.MandeNet == true ? 2 : 1,
        AsnadDar: row.AsnadDar == true ? 2 : 1,
        Sood: row.Sood == true ? 2 : 1,
        TblComboIdGrp8: row.TblComboIdGrp8 == 1179 ? 3 : row.TblComboIdGrp8 == 1178 ? 2 : row.TblComboIdGrp8 == 1650 ? 8 : row.TblComboIdGrp8 == 1177 ? 1 : 'NF',
        User: row.User,
        Aza: row.Aza,
        Baje: row.Baje,
        SMSBank: row.SMSBank == true ? 2 : 1,
        TedadDB: row.TedadDB,
        Tashilat: row.Tashilat == true ? 2 : 1,
        GardeshTashilat: row.GardeshTashilat == true ? 2 : 1,
        OnlineUser: row.OnlineUser,
        TelBank: row.TelBank == true ? 2 : 1,
        MobileBank: row.MobileBank == true ? 2 : 1,
        TlgBank: row.TlgBank == true ? 2 : 1,
        isEtebar: row.isEtebar == true ? 2 : 1,
        isPos: row.isPos == true ? 2 : 1,
        isFinger: row.isFinger == true ? 2 : 1,
        isAni: row.isAni == true ? 2 : 1,
        isATM: row.isATM == true ? 2 : 1,
        isCard: row.isCard == true ? 2 : 1,
        isShetab: row.isShetab == true ? 2 : 1,
        OutUser: row.OutUser,
        OutBaje: row.OutBaje,
        ShobeCount: row.ShobeCount,
        TedadBajeMoshtari: row.TedadBajeMoshtari,
        SahmiyeBandiVaPardaxt: row.SahmiyeBandiVaPardaxt == true ? 2 : 1,
        Amniyat: row.Amniyat == true ? 2 : 1,
        TolidSheba: row.TolidSheba == true ? 2 : 1,
        PayaVaSatna: row.PayaVaSatna == true ? 2 : 1,

        // ExpDate : row.ExpDate,
        // DateOfLastEntry: row.DateOfLastEntry,
        // ChargeAmount : row.ChargeAmount,
        // LockName : row.LockName,
        // Static:1,

      }
      var data = []
      let str=''
      for (const [key, value] of Object.entries(Sample)) {
        data.push(`${value}`)
        str+=value
        // console.log(key);
        //این شرط باید بر روی آخرین  key  آبجکت Sample  باشد
        if (key=='PayaVaSatna') {
          
        }
        else{
          str+='.'
        }
        
      }
      
      str=str+','+row.ExpDate+','+row.DateOfLastEntry+','+ row.ChargeAmount+','+row.LockName+','+1
      // navigator.clipboard.writeText(data)
      navigator.clipboard.writeText(str)
      this.$toasted.success(' کد قفل ' + ' کپی شد', {})
    },
    AddRow() {
      var row = {}
      row.CustomerId = this.CustomerId
      row.CustCode = this.CustCode
      this.$router.push({ name: 'DetailModules', params: { Status: 'Add', DataRow: row ,CustomerName:this.CustomerName} })
    },
  },
}
</script>
<style>
#ModulsTable th {
  font-weight: normal !important;
  white-space: nowrap !important;
}
#ModulsTable table {
  font-size: x-small;
}
#ModulsTable i {
  font-size: small;
}
</style>
